import { STATUSES } from '../config/CONSTANTS'
import { validate } from 'uuid'

export const toSync = workorders => {
  const validWorkorders    = workorders.filter(wo => !wo.error)
  const errorWorkorders    = workorders.filter(wo => wo.error)
  const unsyncedWorkorders = validWorkorders.filter(wo => !wo.synced)
  const syncingWorkorders  = validWorkorders.filter(wo => wo.syncing)

  return [...unsyncedWorkorders, ...syncingWorkorders, ...errorWorkorders]
}

// Errored workorders await a manual retry and never auto-sync, so they must not
// gate the list refresh.
export const pendingSync = workorders =>
  toSync(workorders).filter(workorder => !workorder.error)

// A failed sync never retries on its own: it waits for a manual retry.
export const withSyncError = workorders => workorders.filter(workorder => !!workorder.error)

// A retry ends in an error again or in a clean synced state. A workorder that left the
// list (an offline create that got its server id) has nothing left to wait for either.
export const syncSettled = workorder =>
  !workorder || !!workorder.error || (!!workorder.synced && !workorder.syncing)

const ABSENCE = 'absence'

export const newIndexDate = (date_int, number) => {
  const newDateDiff = date_int + number
  const updatedDate = new Date
  updatedDate.setDate(updatedDate.getDate() + newDateDiff)
  return { updatedDate, newDateDiff }
}

// Cents to euros
export const to_euro = cents => {
  const euros = (cents / 100).toFixed(2)
  return `${euros} €`
}

// Euros to cents
export const to_cents = euro => {
  const cents = (euro * 100)
  return cents
}

export const formatValue2f = value => {
  return (Math.round(value * 100) / 100).toFixed(2);
}

// Check if workorder was created offline by id being an UUID
export const isOfflineWorkorder = workorder => {
  return workorder && validate(workorder.id)
}